import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { setI18nLanguageStorage } from "../../shared/storageUtils";
import { setDayJSLocale } from "../dayjs/utils";
import { setMomentLocale } from "../moment/utils";
import { DEFAULT_LOCALE, Locales } from "./constants";
import * as esPY from "./locales/es-PY";
import * as ptBR from "./locales/pt-BR";
import { getUserLocale } from "./utils";

function getInitialLanguage() {
  const userLocale = getUserLocale();
  setDayJSLocale(userLocale);
  setMomentLocale(userLocale);
  setI18nLanguageStorage(userLocale);
  return userLocale;
}

i18n.use(initReactI18next).init({
  lng: getInitialLanguage(),
  fallbackLng: DEFAULT_LOCALE,
  resources: {
    [Locales.PT_BR]: ptBR,
    [Locales.ES_PY]: esPY,
  },
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
  debug: process.env.NODE_ENV === "development",
});

export default i18n;
